import type { WithActiveBranchId } from '@app/api/shared';

export enum UserChatEndpoints {
  Create = 'Create',
  List = 'list',
  SendMessage = 'sendMessage',
  GetMessages = 'getMessages',
  Typing = 'typing',
  MarkAsRead = 'markAsRead',
  GetOrCreateAiUserChat = 'getOrCreateAiUserChat',
  ResetContext = 'resetContext',
}

export enum UserChatType {
  Personal = 'Personal',
  Self = 'Self',
  Group = 'Group',
}

export enum UserMessageType {
  Text = 'Text',
  File = 'File',
  System = 'System',
}

export enum UserChatFilter {
  All = 0,
  Unread = 1,
  Archived = 2,
}

export interface ModelCreateUserChatRequest {
  ParticipantIds: number[];
  ChatType: UserChatType;
  IsDefault?: boolean;
}

export interface ModelUserChatDto {
  ChatId: number;
  ChatType?: UserChatType | null;
  IsDefault: boolean;
  ParticipantIds?: number[] | null;
}

export interface ModelUserChatParticipantDto {
  Id: number;
  Name?: string | null;
  PhotoBase64?: string | null;
}

export interface ModelUserChatLastMessageDto {
  Text?: string | null;
  Sender?: ModelUserChatParticipantDto;
  CreatedAt: string;
}

export interface ModelSendUserChatMessageRequest {
  ChatId: number;
  MessageText: string;
  ReplyToMessageId?: number | null;
}

export interface ModelUserChatMessagePreviewDto {
  Id: number;
  Text?: string | null;
}

export interface ModelUserChatMessageDto {
  Id: number;
  Text?: string | null;
  Type: UserMessageType;
  CreatedAt: string;
  EditedAt?: string | null;
  Sender?: ModelUserChatParticipantDto;
  Reads?: ModelUserChatParticipantDto[] | null;
  ReplyTo?: ModelUserChatMessagePreviewDto;
}

export interface ModelUserChatListItem {
  Id: number;
  ChatType: UserChatType;
  Participants?: ModelUserChatParticipantDto[] | null;
  LastMessage?: ModelUserChatLastMessageDto;
  UnreadCount: number;
  IsMuted: boolean;
  LastMessageAt?: string | null;
}

export interface ModelUserChatListResult {
  Data?: ModelUserChatListItem[] | null;
  CurrentPage: number;
  TotalPages: number;
  TotalItems: number;
}

export interface ModelUserChatMarkReadRequest {
  ChatId?: number;
  MessageId?: number;
}

export interface ModelUserChatMarkReadResult {
  MarkedCount: number;
  LastReadAt: string;
  UnreadCount: number;
}

export interface ModelUserChatTypingRequest {
  chatId: number;
}

export type CreateUserChatRequest = WithActiveBranchId<{
  data: ModelCreateUserChatRequest;
}>;

export type ListUserChatsRequest = WithActiveBranchId<{
  page?: number;
  limit?: number;
  filter?: UserChatFilter;
  search?: string;
}>;

export type SendUserChatMessageRequest = WithActiveBranchId<{
  data: ModelSendUserChatMessageRequest;
}>;

export type GetUserChatMessagesRequest = WithActiveBranchId<{
  chatId?: number;
  beforeMessageId?: number;
  limit?: number;
}>;

export type UserChatTypingRequest = WithActiveBranchId<{
  data: ModelUserChatTypingRequest;
}>;

export type UserChatMarkAsReadRequest = WithActiveBranchId<{
  data: ModelUserChatMarkReadRequest;
}>;

export type GetOrCreateAiUserChatRequest = WithActiveBranchId;

export type UserChatResetContextRequest = WithActiveBranchId<{
  data: ModelUserChatTypingRequest;
}>;

export type CreateUserChatResponse = ModelUserChatDto;
export type ListUserChatsResponse = ModelUserChatListResult;
export type SendUserChatMessageResponse = ModelUserChatLastMessageDto;
export type GetUserChatMessagesResponse = ModelUserChatMessageDto[];
export type UserChatTypingResponse = void;
export type UserChatMarkAsReadResponse = ModelUserChatMarkReadResult;
export type GetOrCreateAiUserChatResponse = ModelUserChatDto;
export type UserChatResetContextResponse = void;
